/** Shared dismiss flag for dashboard push tip (survives opt-in sheet grant). */

export const NATIVE_PUSH_TIP_DISMISSED_EVENT = "bilenia:nativePushTipDismissed";

const tipDismissKey = (userId: string) =>
  `bilenia.nativePush.tipDismissed.${userId}`;

export function wasNativePushTipDismissed(userId: string): boolean {
  try {
    return localStorage.getItem(tipDismissKey(userId)) === "1";
  } catch {
    return false;
  }
}

export function markNativePushTipDismissed(userId: string): void {
  try {
    localStorage.setItem(tipDismissKey(userId), "1");
  } catch {
    /* ignore */
  }
  try {
    window.dispatchEvent(new Event(NATIVE_PUSH_TIP_DISMISSED_EVENT));
  } catch {
    /* ignore */
  }
}
